import React from "react";
import PropTypes from "prop-types";
import MarkerGraph from "./markerGraph";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import _ from "lodash";

const BasicMarkerDetails = ({ marker }) => {
  const { remark, feedback, quickTips } = marker;

  let tipsSection;
  if (quickTips) {
    tipsSection = (
      <div className="grid__wrapper">
        {quickTips.map((info, index) =>
          <div key={index} className="grid__item grid__item--two">
            <figure>
              <img
                alt=""
                src={`/assets/images/wellness/hra/quicktips/${info.quickTipTag}.png`}
              />
            </figure>
            <p>
              <FormattedMessage
                id={(info.quickTipText || "").trim()}
                defaultMessage={info.quickTipText}
              />
            </p>
          </div>
        )}
      </div>
    );
  }

  const feedbackSection = (
    <div>
      <h4>
        {remark && !_.isEmpty(remark)
          ? <FormattedMessage
              id={(remark || "").trim()}
              defaultMessage={remark}
            />
          : null}
      </h4>
      <p>
        {feedback && !_.isEmpty(feedback)
          ? <FormattedMessage
              id={(feedback || "").trim()}
              defaultMessage={feedback}
            />
          : null}
      </p>
    </div>
  );

  return (
    <div>
      {feedbackSection}
      {tipsSection}
    </div>
  );
};

BasicMarkerDetails.propTypes = {
  marker: PropTypes.object,
};

const AdvancedMarkerDetails = ({ marker, details }) => {
  const { feedback, ranges } = marker;
  const { description, shortDescription } = details;
  const aboutInfo = description || shortDescription;

  const graphSection =
    ranges && <MarkerGraph ranges={ranges} marker={details} />;
  const aboutSection =
    aboutInfo &&
    <div>
      <h3>
        <FormattedMessage {...messages.aboutDescription} />
      </h3>
      <p>
        <FormattedMessage
          id={(aboutInfo || "").trim()}
          defaultMessage={aboutInfo}
        />
      </p>
    </div>;
  const feedbackSection =
    feedback &&
    <div>
      <h3>
        <FormattedMessage {...messages.suggestionsDescription} />
      </h3>
      <p>
        <FormattedMessage
          id={(feedback || "").trim()}
          defaultMessage={feedback}
        />
      </p>
    </div>;

  return (
    <div>
      {graphSection}
      {aboutSection}
      {feedbackSection}
    </div>
  );
};

AdvancedMarkerDetails.propTypes = {
  marker: PropTypes.object,
  details: PropTypes.object,
};

const MarkerDetails = ({ marker, details, basic }) =>
  basic
    ? <BasicMarkerDetails marker={marker} />
    : <AdvancedMarkerDetails marker={marker} details={details} />;

MarkerDetails.propTypes = {
  marker: PropTypes.object.isRequired,
  details: PropTypes.object,
  basic: PropTypes.bool,
};

export default MarkerDetails;



// WEBPACK FOOTER //
// ./components/employee/wellness/markerDetails.jsx